import { faEllipsis, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppDispatch } from "Store/hooks";
import { setErrorState } from "Components/Basic/ErrorBoundary/redux/slice";
import { Dropdown, MenuProps, Popconfirm } from "antd";
import { setLoadingState } from "Components/Basic/full_page_loader/redux/slice";
import { deleteUser } from "../../redux/thunks";
import "Features/Users/users.index.css";

export const ActionRenderer = (_: any, record: any) => {
  const dispatch = useAppDispatch();

  const deleteSelectedUser = async () => {
    try {
      dispatch(setLoadingState(true));
      await dispatch(deleteUser(record)).unwrap();
      dispatch(
        setErrorState({
          message: "Success",
          description: "User deleted successfully",
          placement: "topRight",
          type: "success",
        })
      );
    } catch (err: any) {
      dispatch(
        setErrorState({
          message: "Error",
          description: err.message,
          placement: "topRight",
          type: "error",
        })
      );
    } finally {
      dispatch(setLoadingState(false));
    }
  };

  const handleDelete = () => {
    deleteSelectedUser();
  };

  const items: MenuProps["items"] = [
    {
      label: (
        <Popconfirm
          title={"Delete User"}
          description={"Are you sure you want to delete this user?"}
          onConfirm={handleDelete}
        >
          <div className={"action-items action-items-red"}>
            <FontAwesomeIcon
              className="action-items-icon action-items-icon-red"
              icon={faTrashAlt}
            />
            Delete User
          </div>
        </Popconfirm>
      ),
      danger: true,
      key: "1",
    },
  ];
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Dropdown menu={{ items }} trigger={["click"]}>
        <FontAwesomeIcon
          style={{ cursor: "pointer" }}
          icon={faEllipsis}
          rotation={90}
        />
      </Dropdown>
    </div>
  );
};
